import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {combineEpics} from 'redux-observable';

import {catchError, mergeMap, filter} from 'rxjs/operators';

import {from, of} from 'rxjs';

import type {GatewayError} from '@yandex-data-ui/gateway';

import {WikiEpic} from '../types';

import {actions as asyncOperationsActions} from './async-operations';

interface StartMovePayload {
    withChildren: boolean;
    source: string;
    target: string;
}

interface SetMoveTaskStatePayload {
    id: string;
    taskId?: string;
    error?: GatewayError;
    alreadyRunning?: boolean;
}
export interface ClusterState {
    [id: string]: {
        data: {
            moveTaskId?: string;
            moveTaskError?: GatewayError;
            moveTaskAlreadyRunning?: boolean;
        };
    };
}

const initialState: ClusterState = {};

const {reducer, actions} = createSlice({
    name: 'clusters',
    initialState,
    reducers: {
        startMove(_state, _payload: PayloadAction<StartMovePayload>) {},
        setMoveTaskState(
            state,
            {payload: {id, taskId, error, alreadyRunning}}: PayloadAction<SetMoveTaskStatePayload>,
        ) {
            state[id] = {
                data: {
                    ...state[id]?.data,
                    moveTaskId: taskId,
                    moveTaskError: error,
                    moveTaskAlreadyRunning: alreadyRunning,
                },
            };
        },
    },
});

const onMoveClusterTaskIdGetEpic: WikiEpic = (action$, _state$, {sdk}) =>
    action$.pipe(
        filter(actions.startMove.match),
        mergeMap(({payload: {withChildren, source, target}}) => {
            return from(
                sdk.wiki.asyncMoveCluster({
                    with_children: withChildren,
                    source,
                    target,
                }),
            ).pipe(
                mergeMap(({task_id: taskId}) =>
                    of(
                        actions.setMoveTaskState({
                            id: source,
                            taskId,
                        }),
                        asyncOperationsActions.startPoll({taskId}),
                    ),
                ),
                catchError((error: GatewayError) => {
                    const detailsData =
                        error.details &&
                        (error.details.data as {
                            task_id: string;
                        });

                    if (error.code === 'ALREADY_RUNNING' && detailsData) {
                        return of(
                            actions.setMoveTaskState({
                                id: source,
                                taskId: detailsData.task_id,
                                alreadyRunning: true,
                            }),
                            asyncOperationsActions.restartPoll({
                                taskId: detailsData.task_id,
                            }),
                        );
                    }

                    return of(
                        actions.setMoveTaskState({
                            id: source,
                            error,
                        }),
                    );
                }),
            );
        }),
    );

const epic = combineEpics<WikiEpic>(onMoveClusterTaskIdGetEpic);

export {epic, reducer, actions};
